import { ResumeDataDto, apiRoutes } from "@sr-partner-portal/common";
import ky from "ky";

class Api {
    static async getResumeData(token: string) {
        const response = await ky
            .get<{ resumeDataDto: ResumeDataDto }>(
                apiRoutes().resume().getData(false, { token }).build(),
            )
            .json();

        const resumeData = ResumeDataDto.createFromData(
            response.resumeDataDto,
        ).toResumeData();

        return resumeData;
    }

    static async sendResume({
        token,
        resumeBlob,
        email,
    }: {
        token: string;
        resumeBlob: Blob;
        email?: string;
    }) {
        const formData = new FormData();
        formData.append("resume", resumeBlob, "Lebenslauf.pdf");
        formData.append("email", email);

        await ky.post(
            apiRoutes().resume().sendResume(false, { token }).build(),
            {
                body: formData,
            },
        );
    }

    static async updatePersonalInfo({
        token,
        data,
    }: {
        token: string;
        data: {
            name?: string;
            emailAddress?: string;
            phoneNumber?: string;
        };
    }) {
        await ky.put(
            apiRoutes()
                .applicants()
                .updatePersonalInfo(false, { token })
                .build(),
            {
                json: {
                    applicantPersonalInfoUpdateDto: data,
                },
            },
        );
    }
}

export { Api };
